import { useContext } from "react";
import ToastContext from "../../config/context/toastContext";
import styles from "../../css/toast.module.css";
import { generateRandomKey } from "../../lib/GenerateKey";
import Toast from "./Toast";

const ToastList = () => {
  const { toastList, removeFromToastFromList } = useContext(ToastContext);
  const keyGenerator = generateRandomKey();

  return (
    <div className={styles.toastContainer}>
      {/* **TODO *
      {toastList &&
        toastList.length > 0 &&
        toastList.map((lis, i) => (
          <Toast
            key={keyGenerator.next().value}
            status={lis.status}
            text={lis.text}
            index={i}
            selfDestructible={lis.selfDestructible}
            executable={lis.executable}
            executableFunction={lis.executableFunction}
            removeToastFromList={removeFromToastFromList}
          />
          <></>
        ))} */}
    </div>
  );
};

export default ToastList;
